export const APP_NAME = "Hub";
export const APP_SCHEME = "hub"; // hub://contact/<id>, hub://oauth/return, hub://invite/<token>
export const DEFAULT_SERVER_URL = "http://localhost:4100";
/** The Hub server everyone uses. Release builds of the Mac and web apps talk only to this address. */
export const PUBLIC_SERVER_URL = "https://app.thyic.com";
export const SCHEMA_VERSION = 1;
/** Relationship strength thresholds (0..1 score) -> bucket. */
export const RELATIONSHIP_BUCKETS = {
    closest: 0.75, // bucket 1
    closer: 0.5, // bucket 2
    close: 0.25, // bucket 3
};
export const RELATIONSHIP_TIER_LABELS = {
    0: "",
    1: "Acquaintance",
    2: "Close",
    3: "Closer",
    4: "Closest",
};
export const BUCKET_LABELS = {
    1: "Closest",
    2: "Closer",
    3: "Close",
    4: "",
};
/** Automatic reconnect cadence from relationship score. */
export function automaticCadenceForScore(score) {
    if (score >= RELATIONSHIP_BUCKETS.closest)
        return "weekly";
    if (score >= RELATIONSHIP_BUCKETS.closer)
        return "monthly";
    if (score >= RELATIONSHIP_BUCKETS.close)
        return "quarterly";
    return "yearly";
}
export const CADENCE_DAYS = {
    weekly: 7,
    monthly: 30,
    quarterly: 91,
    yearly: 365,
};
export const DEFAULT_RECONNECTS_PER_DAY = 3;
export const DEFAULT_DAILY_FOCUS_ITEMS = 4;
export const RECENT_INTERACTION_DAYS = 14;
export const DUPLICATE_AUTOMERGE_SCORE = 1.0;
export const DUPLICATE_SUGGEST_SCORE = 0.6;
/** Matching thresholds. */
export const MATCHING = {
    threshold: 0.25,
    validatedThreshold: 0.15,
    /** Text similarity a candidate must reach on its own; network and activity bonuses never carry a match alone. */
    minTextScore: 0.2,
    adjudicateMin: 0.3,
    adjudicateMax: 0.72,
    lexicalWeight: 0.55,
    embeddingWeight: 0.45,
    modelWeight: 0.7,
    computedWeight: 0.3,
    highLabel: 0.6,
    mediumLabel: 0.35,
    dashboardLimit: 15,
    opportunityExpiryDays: 14,
    reviewExpiryDays: { not_interested: 30, default: 365 },
};
export const CREDITS = {
    acceptMatch: -1,
    shareAccepted: 1,
    shareAcceptedWithInvite: 2,
    contactShareAccepted: -1,
    contactShareRewarded: 2,
    reveal: -1,
    fiveStarReview: 1,
    referralSignup: 1,
    invitedNeederJoined: 1,
    facilitationCompleted: 1,
};
export const KEYBOARD_SHORTCUTS = [
    { title: "Command bar", keys: ["Mod", "K"], group: "Global" },
    { title: "Search", keys: ["/"], group: "Global" },
    { title: "Keyboard shortcuts", keys: ["?"], group: "Global" },
    { title: "Toggle sidebar", keys: ["["], group: "Global" },
    { title: "Go back", keys: ["Esc"], group: "Global" },
    { title: "Home", keys: ["g", "h"], group: "Navigate" },
    { title: "People", keys: ["g", "p"], group: "Navigate" },
    { title: "Starred", keys: ["g", "s"], group: "Navigate" },
    { title: "Matches", keys: ["g", "m"], group: "Navigate" },
    { title: "Jump to group", keys: ["g", "1-9"], group: "Navigate" },
    { title: "Move up / down", keys: ["↑", "↓"], group: "Lists" },
    { title: "Open focused item", keys: ["Enter"], group: "Lists" },
    { title: "Dismiss item", keys: ["e"], group: "Lists" },
    { title: "Create a person", keys: ["p"], group: "People" },
    { title: "Add a note", keys: ["n"], group: "People" },
    { title: "Add a reminder", keys: ["r"], group: "People" },
    { title: "Add to group", keys: ["l"], group: "People" },
    { title: "Edit reconnect cadence", keys: ["h"], group: "People" },
    { title: "Contact person", keys: ["c"], group: "People" },
    { title: "Star / unstar", keys: ["s"], group: "People" },
    { title: "Merge", keys: ["m"], group: "People" },
    { title: "Archive", keys: ["#"], group: "People" },
    { title: "Add a need", keys: ["w"], group: "Network" },
    { title: "Add a service", keys: ["o"], group: "Network" },
    { title: "Save / submit", keys: ["Mod", "Enter"], group: "Editing" },
];
//# sourceMappingURL=constants.js.map